import { Filters } from '../../Filters';
export function getShiftX(spectrum) {
    const filter = spectrum?.filters?.find((filter) => filter.name === Filters.shiftX.id);
    return filter?.flag ? filter.value.shift : 0;
}
//# sourceMappingURL=getShiftX.js.map